import HelpedPerson from './HelpedPersonTab/HelpedPerson';
import ProjectEvolutionTab from './ProjectEvolutionTab/ProjectEvolutionTab';
import ProjectsTab from './RequestsTab/RequestsTab';
import StakeholdersTab from './StakeholdersTab/StakeholdersTab';
import AppointmentRequestsTab from './AppointmentRequestsTab/AppointmentRequestsTab';
import { Person } from 'services/person/person.types';

export const GetPersonDetailsTabs = (person: Person, setPerson: (person: Person) => void) => [
    {
        id: 1,
        link: ":personId",
        label: 'Personne soutenue',
        component: <HelpedPerson person={person} setPerson={setPerson} />
    },
    {
        id: 2,
        link: ":personId/stakeholders",
        label: 'Proche(s)',
        component: <StakeholdersTab person={person} />,
    },
    {
        id: 3,
        link: ":personId/project/:projectId/requests",
        label: 'Demandes',
        component: <ProjectsTab person={person} />
    },
    {
        id: 4,
        link: ":personId/project/:projectId/events",
        label: 'Évolution du projet de vie',
        component: <ProjectEvolutionTab person={person} />,
    },
    {
        id: 5,
        link: ":personId/appointments",
        label: 'Demandes de rendez-vous',
        component: <AppointmentRequestsTab person={person} />
    }
];
